<div class="actions-panel">
  <div class="panel-header">
    <h3 class="panel-title">STEPS</h3>
    <div class="panel-actions" *ngIf="recordedSteps.length > 0">
      <button class="btn-clear"  (click)="onClear()" [featureActionState]="'MOBILE_AUTOMATION'">🗑 Clear All</button>
    </div>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="recordedSteps.length === 0">
    <div class="empty-icon"></div>
    <p>{{ isRecording ? 'Perform gestures on the device to record them…' : 'Press ⏺ Record then interact with the device.' }}</p>
  </div>

  <!-- Steps list -->
  <div class="steps-list" *ngIf="recordedSteps.length > 0">
    <div class="step-group" *ngFor="let stepGroup of recordedSteps"
         [class.step-group--active]="stepGroup.name === currentStepName && isRecording">

      <!-- Step header -->
      <div class="step-header" (click)="renamingStep !== stepGroup.name && toggleCollapse(stepGroup)">
        <span class="step-collapse-icon">{{ stepGroup.collapsed ? '▶' : '▼' }}</span>

        <!-- Normal view -->
        <ng-container *ngIf="renamingStep !== stepGroup.name">
          <span class="step-name">
            <span class="step-badge" [class.step-badge--live]="stepGroup.name === currentStepName && isRecording">
              {{ stepGroup.name === currentStepName && isRecording ? '⏺' : '' }}
            </span>
            {{ stepGroup.name }}
          </span>

          <!-- Edit -->
          <button class="step-action-btn step-edit-btn"
                  (click)="startRename(stepGroup.name, $event)"
                  title="Rename step"
                  [featureActionState]="'MOBILE_AUTOMATION'">Edit</button>

            <!-- Clear actions in this step -->
            <button class="step-action-btn step-clear-btn"
              (click)="confirmClearStep(stepGroup.name); $event.stopPropagation()"
              title="Clear actions"
              [featureActionState]="'MOBILE_AUTOMATION'">Clear</button>

          <!-- Save to Canvas -->
          <button
            class="step-action-btn step-save-btn"
            [class.step-save-btn--saving]="getSaveState(stepGroup.name) === 'saving'"
            [disabled]="getSaveState(stepGroup.name) === 'saving'"
            (click)="onSaveStep(stepGroup, $event)"
            title="Save to Canvas"
            [featureActionState]="'MOBILE_AUTOMATION'">
            <span *ngIf="getSaveState(stepGroup.name) !== 'saving'">Save to Canvas</span>
            <span *ngIf="getSaveState(stepGroup.name) === 'saving'" class="save-spinner"></span>
          </button>
        </ng-container>

        <!-- Inline rename -->
        <ng-container *ngIf="renamingStep === stepGroup.name">
          <div class="rename-field-wrap" (click)="$event.stopPropagation()">

            <div class="rename-input-row">
              <input
                class="step-rename-input"
                [class.step-rename-input--error]="renameError !== null"
                [(ngModel)]="renameValue"
                (ngModelChange)="validateRename($event)"
                (keydown.enter)="confirmRename()"
                (keydown.escape)="cancelRename()"
                maxlength="60"
                autofocus />

              <span class="rename-spinner" *ngIf="isLoadingRenameCheck" title="Checking…"></span>

              <ng-container *ngIf="!isLoadingRenameCheck">
                <button class="step-rename-confirm"
                        [disabled]="!isRenameValid"
                        (click)="confirmRename(); $event.stopPropagation()"
                        title="Save name"
                        [featureActionState]="'MOBILE_AUTOMATION'">✔</button>
                <button class="step-rename-cancel"
                        (click)="cancelRename(); $event.stopPropagation()"
                        title="Cancel"
                        [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
              </ng-container>
            </div>

            <div class="rename-status rename-status--warn"
                 *ngIf="renameCheckLoadError && !isLoadingRenameCheck">
              ⚠️ Could not verify against saved steps.
            </div>

            <div class="rename-error" *ngIf="renameError !== null && !isLoadingRenameCheck">
              {{ renameErrorMessage }}
            </div>

          </div>
        </ng-container>

        <span class="step-count" *ngIf="renamingStep !== stepGroup.name">
          {{ stepGroup.actions.length }} action{{ stepGroup.actions.length !== 1 ? 's' : '' }}
        </span>
        <button class="step-remove" *ngIf="renamingStep !== stepGroup.name"
                (click)="onRemoveStep(stepGroup.name); $event.stopPropagation()" title="Remove step" [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
      </div>

      <!-- Step actions table -->
      <div class="step-actions" *ngIf="!stepGroup.collapsed">

        <div class="step-empty" *ngIf="stepGroup.actions.length === 0">
          <span *ngIf="stepGroup.name === currentStepName && isRecording">Waiting for gestures…</span>
          <span *ngIf="!(stepGroup.name === currentStepName && isRecording)">No actions recorded</span>
        </div>

        <ng-container *ngIf="stepGroup.actions.length > 0">
          <div class="table-body">
            <div class="table-row" *ngFor="let a of stepGroup.actions" (dblclick)="onRowDoubleClick(a)">

              <div class="col-cmd">
                <span class="cmd-pill">{{ a.action }}</span>
              </div>

              <div class="col-target" *ngIf="!isCoordAction(a.action) && !isHardwareKey(a.action)">
                <ng-container *ngIf="!isOpenCmd(a.action)">
                  <span class="cell-text" [title]="getPrimaryLocator(a)">{{ getTargetDisplayName(a) }}</span>
                  <button class="locator-btn" *ngIf="a.element" (click)="openLocators(a, $event)" title="View locators">⚙</button>
                </ng-container>
              </div>

              <!-- keyboard-action: show value inline + delete, no target column -->
              <ng-container *ngIf="isKeyboardAction(a.action)">
                <div class="col-value">
                  <span class="cell-text">{{ a.value }}</span>
                </div>
                <div class="col-del">
                  <button class="row-remove" (click)="onRemoveAction(stepGroup.name, a.id); $event.stopPropagation()" [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
                </div>
              </ng-container>

              <div class="col-value" [class.col-value--wide]="isCoordAction(a.action)" *ngIf="!isHardwareKey(a.action)">

                <ng-container *ngIf="isCoordAction(a.action)">
                  <span class="coord-chip">{{ a.coordinates.x }}, {{ a.coordinates.y }}</span>
                  <ng-container *ngIf="a.swipeTo">
                    <span class="coord-arrow">→</span>
                    <span class="coord-chip">{{ a.swipeTo.x }}, {{ a.swipeTo.y }}</span>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="isOpenCmd(a.action)">
                  <span class="cell-text url-text" [title]="getPrimaryLocator(a)">{{ getPrimaryLocator(a) }}</span>
                </ng-container>

                <ng-container *ngIf="!isCoordAction(a.action) && !isOpenCmd(a.action) && a.value">
                  <span class="cell-text inspect-value"
                        [class.inspect-value--inspect]="a.action === gestureLiterals.GET_TEXT || a.action === 'get-value'"
                        [title]="a.value">{{ a.value }}</span>
                </ng-container>

                <ng-container *ngIf="a.action === 'slider'">
                  <span class="cell-text inspect-value" [title]="getValueDisplay(a)">
                    {{ getValueDisplay(a) }}
                  </span>
                </ng-container>
              </div>
              <div class="col-del" *ngIf="isHardwareKey(a.action) && !isKeyboardAction(a.action)">
                <button class="row-remove" (click)="onRemoveAction(stepGroup.name, a.id); $event.stopPropagation()" [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
              </div>
              <div class="col-del" *ngIf="!isHardwareKey(a.action)">
                <button class="row-remove" (click)="onRemoveAction(stepGroup.name, a.id); $event.stopPropagation()" [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Toast notifications -->
  <div class="toast-container">
    <div class="toast toast--success" *ngIf="toastMessage && toastType === 'success'">
      <span class="toast-icon">✔</span>
      <span class="toast-text">{{ toastMessage }}</span>
    </div>
    <div class="toast toast--error" *ngIf="toastMessage && toastType === 'error'">
      <span class="toast-icon">✕</span>
      <span class="toast-text">{{ toastMessage }}</span>
    </div>
  </div>

  <!-- Locator popup -->
  <div class="locator-overlay" *ngIf="locatorTarget" (click)="closeLocators()">
    <div class="locator-popup" (click)="$event.stopPropagation()">
      <div class="popup-header">
        <span>Element Locators</span>
        <button class="popup-close" (click)="closeLocators()">✕</button>
      </div>
      <div class="popup-body">

        <div class="locator-row" *ngIf="locatorTarget.element?.xpaths?.absoluteXpath">
          <span class="loc-key">absolute</span>
          <span class="loc-val" [title]="locatorTarget.element!.xpaths!.absoluteXpath">{{ locatorTarget.element!.xpaths!.absoluteXpath }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.xpaths!.absoluteXpath!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.xpaths?.relativeXpath">
          <span class="loc-key">relative</span>
          <span class="loc-val" [title]="locatorTarget.element!.xpaths!.relativeXpath">{{ locatorTarget.element!.xpaths!.relativeXpath }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.xpaths!.relativeXpath!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.xpaths?.textBasedXpath">
          <span class="loc-key">text-xpath</span>
          <span class="loc-val" [title]="locatorTarget.element!.xpaths!.textBasedXpath">{{ locatorTarget.element!.xpaths!.textBasedXpath }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.xpaths!.textBasedXpath!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.xpaths?.resourceIdXpath">
          <span class="loc-key" [class.loc-key--flutter]="isFlutterElement(locatorTarget.element)">
            {{ isFlutterElement(locatorTarget.element) ? 'key-xpath' : 'res-xpath' }}
          </span>
          <span class="loc-val" [title]="locatorTarget.element!.xpaths!.resourceIdXpath">{{ locatorTarget.element!.xpaths!.resourceIdXpath }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.xpaths!.resourceIdXpath!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.xpaths?.contentDescXpath">
          <span class="loc-key" [class.loc-key--flutter]="isFlutterElement(locatorTarget.element)">
            {{ isFlutterElement(locatorTarget.element) ? 'label-xpath' : 'a11y-xpath' }}
          </span>
          <span class="loc-val" [title]="locatorTarget.element!.xpaths!.contentDescXpath">{{ locatorTarget.element!.xpaths!.contentDescXpath }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.xpaths!.contentDescXpath!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.accessibilityId">
          <span class="loc-key" [class.loc-key--flutter]="isFlutterElement(locatorTarget.element)">
            {{ isFlutterElement(locatorTarget.element) ? 'label' : 'a11yId' }}
          </span>
          <span class="loc-val">{{ locatorTarget.element!.accessibilityId }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.accessibilityId!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.resourceId">
          <span class="loc-key" [class.loc-key--flutter]="isFlutterElement(locatorTarget.element)">
            {{ isFlutterElement(locatorTarget.element) ? 'key' : 'resId' }}
          </span>
          <span class="loc-val">{{ locatorTarget.element!.resourceId }}</span>
          <button class="loc-copy" (click)="copyToClipboard(locatorTarget.element!.resourceId!)">📋</button>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.text">
          <span class="loc-key">text</span>
          <span class="loc-val">{{ locatorTarget.element!.text }}</span>
        </div>

        <div class="locator-row" *ngIf="locatorTarget.element?.className">
          <span class="loc-key" [class.loc-key--flutter]="isFlutterElement(locatorTarget.element)">
            {{ isFlutterElement(locatorTarget.element) ? 'widget' : 'class' }}
          </span>
          <span class="loc-val">
            {{ locatorTarget.element!.className }}
            <span class="loc-flutter-badge" *ngIf="isFlutterElement(locatorTarget.element)">Flutter</span>
          </span>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="showConfirmModal" (click)="cancelConfirm()">
    <div class="modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <span class="modal-title">Confirm</span>
      </div>

      <p class="modal-desc">{{ confirmMessage }}</p>

      <div class="modal-actions">
        <button class="btn-modal-cancel" (click)="cancelConfirm()">Cancel</button>
        <button class="btn-modal-confirm" (click)="confirmOk()" [featureActionState]="'MOBILE_AUTOMATION'">Confirm</button>
      </div>
    </div>
  </div>
</div>